// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"62772b83","275":"922662b6","428":"242f077d","430":"63426c17","494":"0382bb08","697":"b0a55c0f","701":"ac7ce0ab","707":"4fd18807","720":"44526d7b","757":"e7b33d04","974":"5aedba18"}[chunkId] + ".chunk.js";
};